import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FFC107', // Jaune ambre
      light: '#FFD54F',
      dark: '#FFA000',
      contrastText: '#000000',
    },
    secondary: {
      main: '#FFB300', // Jaune ambre plus foncé
      light: '#FFE082',
      dark: '#FF8F00',
      contrastText: '#000000',
    },
    background: {
      default: '#FFFDE7', // Jaune très clair pour le fond
      paper: '#FFFFFF',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
    stats: {
      // Palette étendue pour les graphiques
      sectors: [
        '#2196F3', // Bleu
        '#00C49F', // Turquoise
        '#FFC107', // Jaune ambre
        '#FF5722', // Orange
        '#9C27B0', // Violet
        '#4CAF50', // Vert
        '#F44336', // Rouge
        '#3F51B5', // Indigo
        '#795548', // Marron
        '#607D8B', // Bleu gris
        '#E91E63', // Rose
        '#009688', // Sarcelle
      ],
      durations: [
        '#1976D2', // Bleu foncé
        '#388E3C', // Vert foncé
        '#FFA000', // Ambre foncé
        '#D32F2F', // Rouge foncé
        '#7B1FA2', // Violet foncé
        '#00796B', // Sarcelle foncé
        '#303F9F', // Indigo foncé
        '#5D4037', // Marron foncé
        '#C2185B', // Rose foncé
        '#455A64', // Bleu gris foncé
      ],
      competences: {
        bar: '#FFC107', // Couleur principale des barres
        background: '#FFF8E1', // Fond des graphiques
        text: '#212121', // Couleur du texte
      }
    }
  },
  typography: {
    fontFamily: [
      'Roboto',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 500,
      color: '#212121',
    },
    h2: {
      fontWeight: 500,
      color: '#212121',
    },
    h3: {
      fontWeight: 500,
      color: '#212121',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
        },
        contained: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingTop: '16px',
        },
      },
    },
  },
});

export default theme; 